import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

import { ArrowLeftColor, IConClose, SharedButton } from "@components";
import { PATH_HOME } from "@configs";
import { IMemberTier } from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import { RenderMeta, useNotify } from "@utils";
import { Carousel } from "antd";
import { AnimatePresence, LazyMotion, domAnimation, m } from "framer-motion";
import { useEffect, useState } from "react";
import "swiper/components/navigation/navigation.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { Redeemed } from "./shared/Redeemed";

interface IProps {
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentDailyCheckIn = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //push route
    const { warning, error, success } = useNotify();
    const history = useHistory();
    //page props
    const { avatar, fullName, memberTier, isConfirm } = props;
    //redux statex
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const [showpage1, setShowPage1] = useState(true);
    const [showpage4, setShowPage4] = useState(false);
    const [showresult, setShowResult] = useState(false);
    const [isShowPopup, setShowPopup] = useState<boolean>(false);
    const [viewportHeight, setViewportHeight] = useState(0);
    const [showpopuppage, setShowPopupPage] = useState(true);

    useEffect(() => {
        setViewportHeight(window.innerHeight);
    }, []);

    const handleCloseDetail = () => {
        setShowPopup(false);
        closeAllPopup();
    };

    const closeAllPopup = () => {
        setShowPage1(true);
        setShowPage4(false);
        setShowResult(false);
        setShowPopupPage(true);
    };

    const promotionSlide = (currentSlide: number) => {
        //
    };

    return (
        <>
            <RenderMeta title={t("meta.dailycheckin_page")} />
            <StyledDailCheckIn
                themeColor={themes?.themeColor!}
                bgImg={merchant?.luckyDrawDisplaySetting?.backgroundImage!}
                contentColor={merchant?.luckyDrawDisplaySetting?.textColor!}
                themePageColor={merchant?.luckyDrawDisplaySetting?.themeColor!}
            >
                <header>
                    <div className="back-arrow">
                        <ArrowLeftColor
                            onClick={() => history.push(PATH_HOME)}
                            color={merchant?.luckyDrawDisplaySetting?.themeColor}
                        />
                        {/* <span>{t("page.back")}</span> */}
                    </div>
                    <div className="logo-product">
                        {/* <img src="../images/logo-pet.svg" alt="" /> */}
                    </div>
                    {/* <div className="logo-survey">
                        <img src="../images/logo-survey.svg" alt="" />
                        Survey
                    </div> */}
                </header>
                <div className="main-wrapper">
                    <div className="sub-img-main">
                        <img src="../../images/img-robinhood.svg" alt="" />
                    </div>
                    <div className="main-layout">
                        <div className="title-mouth">February 2024</div>
                        <div className="layout-day-calendar">
                            <div className="box-day-calendar">Su</div>
                            <div className="box-day-calendar">Mo</div>
                            <div className="box-day-calendar">Tu</div>
                            <div className="box-day-calendar">We</div>
                            <div className="box-day-calendar">Th</div>
                            <div className="box-day-calendar">Fr</div>
                            <div className="box-day-calendar">Sat</div>
                        </div>
                        <Carousel
                            afterChange={promotionSlide}
                            // dots={merchant?.promotion?.length > 1 ? true : false}
                            dots={false}
                            arrows={true}
                        >
                            <div className="layout-checkin-daily">
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">28</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">29</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">30</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">31</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">1</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">2</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">3</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">28</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">29</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">30</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">31</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">1</div>
                                </div>
                                <div className="box-checkin-daily checked-day">
                                    <div className="img-box-checkin ">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">2</div>
                                </div>
                                <div className="box-checkin-daily checked-day">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">3</div>
                                </div>
                                <div className="box-checkin-daily checked-day">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">4</div>
                                </div>
                                <div className="box-checkin-daily checked-day today">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">5</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">6</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">7</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">8</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin ">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">9</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">10</div>
                                </div>
                            </div>
                            <div className="layout-checkin-daily">
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">28</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">29</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">30</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">31</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">1</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">2</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">3</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">28</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">29</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">30</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">31</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">1</div>
                                </div>
                                <div className="box-checkin-daily checked-day">
                                    <div className="img-box-checkin ">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">2</div>
                                </div>
                                <div className="box-checkin-daily checked-day">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">3</div>
                                </div>
                                <div className="box-checkin-daily checked-day">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">4</div>
                                </div>
                                <div className="box-checkin-daily checked-day today">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">5</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">6</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">7</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">8</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin ">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">9</div>
                                </div>
                                <div className="box-checkin-daily">
                                    <div className="img-box-checkin">
                                        <img src="../../images/ic-coupon-checkin.svg" alt="" />
                                    </div>
                                    <div className="day-checkin">10</div>
                                </div>
                            </div>
                        </Carousel>
                        <div className="layout-btn-checkin">
                            <StyledButton
                                size="large"
                                bg_color={themes?.themeColor!}
                                type="submit"
                                className="confirm-btn btn-text"
                                onClick={() => {
                                    setShowPopup(true);
                                }}
                            >
                                Check-in
                            </StyledButton>
                        </div>
                    </div>
                </div>
                <div className="sub-layout">
                    <div className="title-sub-layout">2024 Jan 1 - 2025 Jan 1</div>
                    <div className="layout-total-checkin">
                        <Swiper slidesPerView={2.3} spaceBetween={10} pagination={false}>
                            <SwiperSlide>
                                <div className="box-total-checkin">
                                    <div className="title-box-total">Check-in 10 day get</div>
                                    <div className="desc-box-total">
                                        <span className="day">1</span>Ticket
                                        <span className="img">
                                            <img src="../../images/ic-ticket.svg" alt="" />
                                        </span>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box-total-checkin">
                                    <div className="title-box-total">Check-in 10 day get</div>
                                    <div className="desc-box-total">
                                        <span className="day">1</span>Ticket
                                        <span className="img">
                                            <img src="../../images/ic-ticket.svg" alt="" />
                                        </span>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box-total-checkin">
                                    <div className="title-box-total">Check-in 10 day get</div>
                                    <div className="desc-box-total">
                                        <span className="day">1</span>Ticket
                                        <span className="img">
                                            <img src="../../images/ic-ticket.svg" alt="" />
                                        </span>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="box-total-checkin">
                                    <div className="title-box-total">Check-in 10 day get</div>
                                    <div className="desc-box-total">
                                        <span className="day">1</span>Ticket
                                        <span className="img">
                                            <img src="../../images/ic-ticket.svg" alt="" />
                                        </span>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
                <div className="condition-wrapper">
                    <div className="title-condition">Conditions</div>
                    <div className="condition-img">
                        <img src="../../images/img-condition.svg" alt="" />
                    </div>
                </div>
                <LazyMotion features={domAnimation}>
                    <AnimatePresence>
                        {isShowPopup && (
                            <>
                                <StyledShowPopup
                                    initial={{ y: viewportHeight }}
                                    animate={{ y: 0 }}
                                    exit={{ y: viewportHeight }}
                                    transition={{ type: "spring", stiffness: 100, damping: 20 }}
                                    themeColor={themes?.themeColor!}
                                    themePageColor={merchant?.luckyDrawDisplaySetting?.themeColor!}
                                >
                                    <div className="page-wrapper">
                                        <div className="close" onClick={handleCloseDetail}>
                                            <IConClose width={16} />
                                        </div>
                                        {showpopuppage ? (
                                            <div className="content-layout">
                                                <div className="content">
                                                    {showpage1 ? (
                                                        <>
                                                            <div className="header-product">
                                                                <div className="layout-img">
                                                                    <div className="img-product">
                                                                        <img
                                                                            src={
                                                                                "../../images/img-detail-mission.png"
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="topic-product">
                                                                    test title
                                                                </div>
                                                                <div className="expier-product">
                                                                    Exp : 12 Dec 2024
                                                                </div>
                                                            </div>
                                                            <div className="content-product">
                                                                <div className="topic-detail">
                                                                    {t("page.conditions")}
                                                                </div>
                                                                {/* <p
                                                                dangerouslySetInnerHTML={{
                                                                    __html: luckyList?.[focusIndex]
                                                                        ?.description,
                                                                }}
                                                            ></p> */}
                                                                <p>
                                                                    Lorem ipsum dolor sit amet
                                                                    consectetur adipisicing elit.
                                                                    Harum praesentium reprehenderit
                                                                    quaerat ut! Blanditiis vero odit
                                                                    quod, molestiae cum itaque,
                                                                    corporis iste laboriosam natus
                                                                    commodi excepturi at dolorum
                                                                    dolor eos!
                                                                </p>
                                                            </div>
                                                            <StyledUsedBtn
                                                                className="btn-redeem"
                                                                themeColor={themes?.themeColor!}
                                                                themePageColor={
                                                                    merchant
                                                                        ?.luckyDrawDisplaySetting
                                                                        ?.themeColor!
                                                                }
                                                                onClick={() => {
                                                                    setShowPage1(false);
                                                                    setShowResult(true);
                                                                    // setShowPopupPage(false);
                                                                }}
                                                            >
                                                                {t("page.participate")}
                                                            </StyledUsedBtn>
                                                        </>
                                                    ) : null}

                                                    {showresult && (
                                                        <>
                                                            <div className="content-info">
                                                                <div className="header-product">
                                                                    <div className="layout-img">
                                                                        <div className="img-product">
                                                                            <img
                                                                                src={
                                                                                    "../../images/img-sub-luckydraw.png"
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="topic-product">
                                                                        test title
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="action-layout">
                                                                <div className="qr-layout">
                                                                    <div className="qr-box">
                                                                        {/* <QRCode
                                                                        value={
                                                                            resultData?.luckydraw
                                                                                ?.ticketCode || ""
                                                                        }
                                                                        size={150}
                                                                    /> */}
                                                                    </div>
                                                                    <StyledCodeButton
                                                                        mainColor={
                                                                            themes?.themeColor
                                                                        }
                                                                        themePageColor={
                                                                            merchant
                                                                                ?.luckyDrawDisplaySetting
                                                                                ?.themeColor!
                                                                        }
                                                                    >
                                                                        {/* {resultData?.luckydraw
                                                                        ?.ticketCode || "---"} */}
                                                                    </StyledCodeButton>
                                                                </div>
                                                                <p className="redeemed-product">
                                                                    <span className="redeemed">
                                                                        <Redeemed color="#336C51" />
                                                                    </span>
                                                                    REDEEMED
                                                                </p>
                                                                <p className="note">
                                                                    {t("page.desLuckydraw")}
                                                                </p>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                </StyledShowPopup>
                                <BlurBackground
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                />
                            </>
                        )}
                    </AnimatePresence>
                </LazyMotion>
            </StyledDailCheckIn>
        </>
    );
};

const StyledDailCheckIn = styled.div<{
    themeColor: string;
    bgImg: string;
    contentColor: string;
    themePageColor: string;
}>`
    width: 100%;
    margin: 0 auto;
    padding: 15px;
    height: 100vh;
    overflow: scroll;
    background-color: #fff;
    background-position: center top;
    background-repeat: no-repeat;
    /* background-image: ${(props) =>
        props?.bgImg !== "" ? `url(${props?.bgImg})` : "../../images/bg-dailycheckin.svg"}; */
    background-image: url("../../images/bg-dailycheckin.svg");
    background-size: cover;
    position: relative;
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        span {
            margin-left: 10px;
            color: ${(props) =>
                props?.themePageColor !== "" ? `${props?.themePageColor}` : "#fff"};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .main-wrapper {
        border-radius: 16px;
        background-color: #fff;
        position: relative;
        min-height: 150px;
        padding: 16px;
        margin-top: 70px;
        margin-bottom: 30px;
        .sub-img-main {
            position: absolute;
            right: 16px;
            top: -50px;
            img {
                width: auto;
                max-height: 83px;
            }
        }
        .main-layout {
            margin-bottom: 20px;
            .slick-arrow {
                position: absolute;
                top: -50px;
                background-position: center;
                background-size: 7px;
                background-repeat: no-repeat;
            }
            .slick-next {
                left: 50%;
                background-image: url("../images/arrow-calendar-right.svg");
            }
            .slick-prev {
                left: 40%;
                background-image: url("../images/arrow-calendar-left.svg");
            }
            .title-mouth {
                font-size: 18px;
                line-height: 22px;
                color: #000;
                font-weight: 600;
            }
            .layout-day-calendar {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
                .box-day-calendar {
                    text-align: center;
                    font-size: 14px;
                    line-height: 20px;
                    padding: 8px 0;
                }
            }
            .layout-checkin-daily {
                display: grid !important;
                grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
                .box-checkin-daily {
                    text-align: center;
                    font-size: 14px;
                    line-height: 20px;
                    padding: 8px 0;
                    position: relative;
                    &:after {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 1px;
                        right: -50%;
                        top: 15px;
                        background-color: #9b9b9b;
                    }
                    .img-box-checkin {
                        position: relative;
                        z-index: 1;
                        img {
                            width: 24px;
                            height: 24px;
                        }
                    }

                    .day-checkin {
                        font-size: 10px;
                        line-height: 13px;
                        color: #9b9b9b;
                    }
                    &:nth-child(7n) {
                        &:after {
                            display: none;
                        }
                    }
                }
                .today {
                    &:after {
                        background-color: #9b9b9b !important;
                    }
                }
            }
            .checked-day {
                img {
                    display: none !important;
                }
                &:before {
                    content: "";
                    background-image: url(../../images/checked-day.svg);
                    background-repeat: no-repeat;
                    background-position: center center;
                    width: 24px;
                    height: 24px;
                    display: block;
                    position: absolute;
                    z-index: 4;
                    top: 4;
                    left: 50%;
                    transform: translateX(-50%);
                }
                .img-box-checkin {
                    height: 28px;
                }
                &:after {
                    background-color: #9b3ea8 !important;
                }
            }
        }
    }
    .sub-layout {
        background-color: #fff;
        border-radius: 16px;
        padding: 16px;
        margin-bottom: 30px;
        .title-sub-layout {
            margin-bottom: 10px;
        }
        .layout-total-checkin {
            .box-total-checkin {
                background-color: #f3f4f9;
                border-radius: 8px;
                padding: 16px;
                .title-box-total {
                    color: #9b9b9b;
                    font-size: 11px;
                    line-height: 14px;
                }
                .desc-box-total {
                    span.day {
                        font-size: 14px;
                        line-height: 17px;
                        font-weight: 600;
                        color: #000;
                        margin-right: 5px;
                    }
                    font-size: 10px;
                    line-height: 13px;
                    color: #525257;
                    span.img {
                        position: relative;
                        margin-left: 5px;
                        display: inline-block;
                        top: 5px;
                        img {
                            width: 20px;
                            height: 20px;
                        }
                    }
                }
            }
        }
    }
    .condition-wrapper {
        .title-condition {
            font-size: 16px;
            line-height: 19px;
            color: #000;
            font-weight: 600;
            margin-bottom: 15px;
            text-align: center;
        }
        .condition-img {
            border-radius: 14px;
            overflow: hidden;
            img {
                width: 100%;
                height: auto;
            }
        }
    }
`;
const StyledButton = styled(SharedButton)`
    width: 100%;
    margin: 26px auto 0 auto;
    padding: 0;
    height: 52px;
    border-radius: 26px;
    .decline-btn {
        background-color: pink !important;
    }
`;
const BlurBackground = styled(m.div)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
`;
const StyledShowPopup = styled(m.div)<{ themeColor: string; themePageColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    /* background: rgba(0, 0, 0, 0.5); */
    z-index: 10;
    /* left: 50%; */
    /* transform: translateX(-50%); */
    flex-direction: column;
    justify-content: end;
    /* transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    } */
    .topic-popup-product {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        justify-content: center;
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        /* animation: bottomtotop 0.5s !important;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        } */
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;
        .close {
            cursor: pointer;
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .form-content-product {
        border-radius: 6px;
        margin-bottom: 10px;
        .title {
            font-size: 16px;
            color: #676767;
            margin: 10px 0;
        }
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        border-color: #d9d9d9 !important;
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        /* margin-bottom: 27px; */
        border-radius: 6px;
    }
    .content-layout-fullpage {
        height: 100vh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #f2e8d7;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        position: relative;
        /* animation: bottomtotop 0.5s !important;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        } */
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .topic-page {
            font-size: 20px;
            text-align: center;
            color: #000;
            font-weight: 600;
        }
    }
    .content-fullpage {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        top: 50%;
        transform: translateY(-52%);
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            border-radius: 16px;
            padding: 20px;
        }
        .btn-redeem {
            color: #fff;
            background: ${(props) =>
                props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.themeColor}`};
            // background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            // border-bottom: 1px solid #F0F0F0;
            padding: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            padding: 16px;
            margin-bottom: 50px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(props) =>
                    props?.themePageColor !== ""
                        ? `${props?.themePageColor}`
                        : `${props?.themeColor}`};
                // color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
        .interception {
            width: 100%;
            // border-bottom: 5px dotted ${(p) => p.theme.colors.cutter};
            border-bottom: 5px dotted #eaeeff;
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                // background: ${(p) => p.theme.colors.cutter};
                background-color: #f2e8d7;
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #fff;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 14px;
                text-align: center;
                color: #000000;
            }
        }
    }
    .content-layout {
        height: auto;
        min-height: 80dvh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        /* animation: bottomtotop 0.5s !important; */
        /* @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        } */
        .content {
            background: transparent !important;
        }
        .btn-redeem {
            color: #fff;
            background: ${(props) =>
                props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.themeColor}`};
            // background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            border-bottom: 1px solid #f0f0f0;
            margin-top: -100px;
            padding-bottom: 20px;
            .result-luckydraw {
                padding: 12px;
                background-color: rgba(51, 108, 81, 0.08);
                border-radius: 12px;
                position: relative;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .result-img-luckydraw {
                    margin-right: 16px;
                    img {
                        width: 100px;
                        height: 100px;
                    }
                }
                .text-giftset {
                    h2 {
                        font-size: 18px;
                        line-height: 21px;
                        color: #000;
                        font-weight: 600;
                    }
                    p {
                        font-size: 12px;
                        line-height: 16px;
                        margin-bottom: 0;
                        color: #9b9b9b;
                    }
                }
            }
            .layout-img {
                text-align: center;
                .img-product {
                    width: 150px;
                    height: 150px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
            .process-product {
                max-width: 200px;
                margin: 10px auto;
                .ant-progress-inner {
                }
                .ant-progress-bg {
                    background-color: ${(p) => p.themeColor};
                }
            }
        }
        .content-product {
            padding: 16px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(props) =>
                    props?.themePageColor !== ""
                        ? `${props?.themePageColor}`
                        : `${props?.themeColor}`};
                // color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
    }
    .content {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            // padding: 10px;
        }
        .interception {
            width: 100%;
            border-bottom: 7px dotted ${(p) => p.theme.colors.cutter};
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                background: ${(p) => p.theme.colors.cutter};
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #f8eff0;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            // background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .code-qr {
                font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                color: #000;
                text-align: center;
            }
            .redeemed-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .pending-product {
                text-align: center;
                font-size: 12px;
                color: #ed773a;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .used-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #9b9b9b;
            }
        }
    }
    .title {
        line-height: 19px;
        color: ${(p) => p.theme.colors.color};
    }
    .desc {
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 16px;
    }
    .desConfirm {
        width: 100%;
        margin-top: 24px;
        text-align: center;
    }
    .confirm-btn-layout {
        margin-top: 100px;
    }
    .btnLayout {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
const StyledUsedBtn = styled.button<{ themeColor: string; themePageColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(props) =>
        props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.themeColor}`};
    // background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;
const StyledCodeButton = styled.div<{ mainColor?: string; themePageColor: string }>`
    position: absolute;
    background: ${(props) =>
        props?.themePageColor !== "" ? `${props?.themePageColor}` : `${props?.mainColor}`};
    // background: ${(p) => p.mainColor};
    border-radius: 80px;
    height: 26px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    bottom: 0;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
`;
